import prefetch from 'owa-service/lib/prefetch';
import { fetchMeetingMessageItems } from './fetchMeetingMessageItems';
import {
    getMeetingItemFetchList,
    clearMeetingItemFetchList,
} from '../utils/meetingItemFetchListOperations';

export const tryPrefetchMeetingMessage = (shouldPrefetch: boolean) => {
    const infoForRsvpCandidateRows = getMeetingItemFetchList();
    if (infoForRsvpCandidateRows.length === 0) {
        return;
    }

    clearMeetingItemFetchList();

    shouldPrefetch
        ? prefetch(() => {
              fetchMeetingMessageItems(infoForRsvpCandidateRows);
          })
        : fetchMeetingMessageItems(infoForRsvpCandidateRows);
};
